<template>
  <div>
    <div class="card ">
      <div class="card-header">
        Summary devices in agents
      </div>
      <div class="card-body" style="padding: 0; overflow-y: auto; max-height: 400px">
      <table class="table table-sm table-bordered">
        <thead>
        <tr>
          <th>Agent</th>
          <th>Count devices</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(count, name) in list" :key="name">
          <td style="min-width: 150px"><b>{{name}}</b></td>
          <td>{{count}}</td>
        </tr>
        </tbody>
      </table>
      </div>
    </div>
  </div>
</template>


<script>

const url = '/admin/release'

export default {
  props: {
    list: {
      type: Object,
    },
  },
  watch: {
    list: {
      handler(n) {
        console.log(n)
      }
    }
  },

}
</script>